module.exports = __webpack_public_path__ + "img/bf.b47265d9.svg";